export class PDCDataReq {
  constructor(
    public contentId: string,
  ) {}
}

export class PostDeleteContentsReq {
  constructor(
    public data: PDCDataReq
  ) {
  }
}
